const $ = jQuery.noConflict();

function scrollPosition(offset = 0) {
    $('[data-animation]').each(function() {
        let scrollTop = $(window).scrollTop();
        let windowHeight = $(window).height();
        let thisPosition = $(this).offset().top;
        thisPosition = thisPosition + offset

        if (scrollTop + windowHeight >= thisPosition) {
            if (!$(this).hasClass('animate__animated')){
                let $this = $(this);
                $this.addClass('animate__animated');
                $this.addClass('animate__' + $this.data('animation'));
                setTimeout(() => {
                    $this.removeClass('animate__' + $this.data('animation'));
                }, 3000);
            }
        }
    });
}

export default scrollPosition;
